import React from 'react';
import Markdown from 'react-markdown';

const MarkdownRenderer = ({ content, className = '' }) => {
  if (!content) return null;
  
  return (
    <div className={`markdown-content ${className}`}>
      <Markdown
        components={{
          // Headings
          h1: ({ children }) => <h1 className="text-2xl font-bold text-purple-300 mt-6 mb-3">{children}</h1>,
          h2: ({ children }) => <h2 className="text-xl font-bold text-purple-300 mt-5 mb-2">{children}</h2>,
          h3: ({ children }) => <h3 className="text-lg font-bold text-purple-400 mt-4 mb-2">{children}</h3>,
          h4: ({ children }) => <h4 className="text-base font-bold text-purple-400 mt-3 mb-1">{children}</h4>,
          
          // Paragraphs
          p: ({ children }) => <p className="mb-3 leading-relaxed">{children}</p>,
          
          // Bold and italic
          strong: ({ children }) => <strong className="font-bold text-purple-300">{children}</strong>,
          em: ({ children }) => <em className="italic text-purple-200">{children}</em>,
          
          // Lists
          ul: ({ children }) => <ul className="list-disc list-inside mb-3 space-y-1 ml-2">{children}</ul>,
          ol: ({ children }) => <ol className="list-decimal list-inside mb-3 space-y-1 ml-2">{children}</ol>,
          li: ({ children }) => <li className="text-[var(--text-secondary)]">{children}</li>,
          
          // Blockquotes
          blockquote: ({ children }) => (
            <blockquote className="border-l-4 border-purple-400 pl-4 my-3 italic text-purple-200 bg-purple-900/20 py-2 rounded-r">
              {children}
            </blockquote>
          ),
          
          // Code
          code: ({ children }) => (
            <code className="bg-purple-900/30 px-1.5 py-0.5 rounded text-purple-300 text-sm">
              {children}
            </code>
          ),
          
          // Horizontal rule
          hr: () => <hr className="border-purple-400/30 my-4" />,
          
          // Links
          a: ({ href, children }) => (
            <a href={href} className="text-purple-400 underline hover:text-purple-300" target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          ),
        }}
      >
        {content}
      </Markdown>
    </div>
  );
};

export default MarkdownRenderer;
